import React, { useState, useEffect} from "react";
import PropTypes from 'prop-types';
import Modal from "components/elements/Modal";
import SignInUp from 'components/elements/SignInUp'
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';


const PrivacyTermsPage = React.lazy(() => import("pages/Privacy"));
const Home = React.lazy(() => import("pages/Home"));
const ResetPassword = React.lazy(() => import("pages/ResetPassword"));
const PasswordChanged = React.lazy(() => import("pages/PasswordChanged"));
const PricingPage = React.lazy(() => import('pages/Pricing'))
const AboutUsPage = React.lazy(() => import('pages/AboutUs'))
const FeautresPage = React.lazy(() => import('pages/Feature'))
const DemoPage = React.lazy(() => import('pages/Demo'))
const HowWorksPage = React.lazy(() => import('pages/HowWorks'))
const NotFound = React.lazy(() => import('pages/NotFound'));


const RoutesList = ({ isMobile }) => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const appEnv = process.env.REACT_APP_ENV;
    const appScheme = process.env.REACT_APP_SCHEME;
    const location = useLocation();
    const canonicalUrl = `${appScheme}${appEnv}${location.pathname}`;

    useEffect(() => {
        if(window.location.pathname.endsWith('/') && window.location.pathname !== '/') {
            const newPath = window.location.pathname.slice(0, -1);
            navigate(newPath, { replace: true })
        }
    }, [navigate]);


    return (
        <Routes>
            <Route
                path="/"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <Home isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/information/:type"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <PrivacyTermsPage isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/password-reset/:token"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <ResetPassword isMobile={ isMobile } />
                    </React.Suspense>
                }
            />

            <Route
                path="/password-updated"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <PasswordChanged isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/Pricing"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <PricingPage isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/how-works"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <HowWorksPage isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/about-us"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <AboutUsPage isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/features/:type"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <FeautresPage isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/demo"
                element={
                    <React.Suspense fallback={<></>}>
                        <Helmet>
                            <link rel="canonical" href={canonicalUrl} />
                        </Helmet>
                        <DemoPage isMobile={ isMobile } />
                    </React.Suspense>
                }
            />
            <Route
                path="/login"
                element={
                    <React.Suspense fallback={<></>}>
                        <SignInUp type='login' onLoadingChange={ setIsLoading } />
                    </React.Suspense>
                }
            />
            <Route
                path="/signup"
                element={
                    <React.Suspense fallback={<></>}>
                        <SignInUp onLoadingChange={ setIsLoading } />
                    </React.Suspense>
                }
            />
            <Route
                path="/forgot-password"
                element={
                    <React.Suspense fallback={<></>}>
                        <SignInUp type='password' onLoadingChange={ setIsLoading } />
                    </React.Suspense>
                }
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

RoutesList.propTypes = {
    isMobile: PropTypes.bool
}

export default RoutesList